import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Step } from '@dealstack/frontend/shared/components/SubstepMenu/step.types';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Text } from '@mantine/core';
import classNames from 'classnames';

interface Props {
	steps: Step[];
	eligibleSteps?: Set<string | number>;
	currentStep: Step | null;
	onNextClick: () => void;
	disableNext?: boolean;
	disableAll?: boolean;
	changeStepTo?: (id: string | number) => Promise<void>;
}

export const ForwardOnlySubstepMenu = (props: Props) => {
	const {
		steps,
		currentStep,
		disableNext,
		disableAll,
		onNextClick,
		changeStepTo,
		eligibleSteps,
	} = props;

	const tCommonUi = useTranslationCommonUi();

	if (!currentStep) {
		return null;
	}

	return (
		<div className="flex items-center forwardOnlySubstepMenu">
			<Text mr="1rem">{currentStep.name}</Text>
			{steps.map((step: Step) => {
				if (step.id === currentStep.id) {
					return (
						<div
							key={step.id}
							className={classNames(
								`flex items-center py-2 px-2 ${disableAll ? 'opacity-50' : ''}`
							)}
						>
							<div className="flex items-center justify-center w-4 h-4 rounded-full border-2 border-solid border-black">
								<div className="w-2 h-2 rounded-full bg-black"></div>
							</div>
						</div>
					);
				} else if (step.status === 'success') {
					return (
						<div
							key={step.id}
							className={`flex items-center py-2 px-2 ${disableAll ? 'opacity-50' : ''}`}
							onClick={() => {
								if (disableAll) {
									return;
								}
								return eligibleSteps && !eligibleSteps.has(step.id)
									? null
									: changeStepTo && changeStepTo(step.id);
							}}
						>
							<div className="bg-green-700 border-2 border-solid border-green-500 rounded-full w-4 h-4" />
						</div>
					);
				} else {
					return (
						<div
							key={step.id}
							className="flex items-center py-2 px-2"
							onClick={() =>
								eligibleSteps && !eligibleSteps.has(step.id)
									? null
									: changeStepTo && changeStepTo(step.id)
							}
						>
							<div className="bg-gray-200 border border-solid border-gray-300 rounded-full w-4 h-4" />
						</div>
					);
				}
			})}
			<UIElementIdentifier identifier={TEST_ELEMENT_IDS.MIP_CREATE_NEXT_BUTTON}>
				<Button
					size="md"
					onClick={onNextClick}
					rightSection={
						<Icon
							variant="arrow-right-v3"
							size="vlg"
							style={{ marginLeft: '0.5rem' }}
						/>
					}
					disabled={disableNext || disableAll}
					ml="1.5rem"
				>
					<Text size="B6Bold">{tCommonUi(`substep_menu.next`)}</Text>
				</Button>
			</UIElementIdentifier>
		</div>
	);
};
